import { isNavigationFailure, Router } from "vue-router";
import { useUserStore } from "@/pinia/user";
import { ElMessage, ElMessageBox } from 'element-plus';

const defaultRoutePath = "/";

// 用户登录白名单 路由name[]
const APP_WHITE_LIST = [
  "Login",
  "evaluateLogin",
  "managerLogin",
  'expertLogin',
  "FoundPwd",
  "NotFound",
  "certInquiry",
  "register",
  'rolechose'
];

export default function routerGuards(router: Router) {
  router.beforeEach(async (to, from, next) => {
    const userStore = useUserStore();
    const storage = sessionStorage
    const callback = () => {
      if ((to.name === "Login")||(to.name === "evaluateLogin")||(to.name === "managerLogin")||(to.name === "expertLogin")||(to.name === "rolechose")) {
        next({ path: defaultRoutePath });
      } else {
        const hasRoute = router.hasRoute(to.name!);
        if (!hasRoute) {
          next({ name: "NotFound" });
        } else {
          next();
        }
      }
    };

    const token = userStore.token;

    if (token) {
      next();
      // 如果有用户信息
    } else {
      if (APP_WHITE_LIST.includes(to.name as string)) {
        // 在免登录名单，直接进入
        next();
        return;
      }
    //   if(userStore.identityId){
    //     if(userStore.identityId == '004001'||userStore.identityId==''||!userStore.identityId){
    //         next({
    //             path: "/login",
    //             query: { redirect: to.fullPath },
    //             replace: true,
    //         });
    //     }else if(userStore.identityId == '004002'){
    //         next({
    //             path: "/evaluateLogin",
    //             replace: true,
    //         });
    //     }else if(userStore.identityId == '004003'){
    //         next({
    //             path: "/managerLogin",
    //             replace: true,
    //         });
    //     }
    //   }
    }
    
    if((to.name!= "examRecordList")&&(to.name!= "studentInfo")&&(to.name!='certificateDeclareManager')){
        storage.setItem('saveSearchParams', JSON.stringify(''))
    }
  });

  router.afterEach((to, from, failure) => {
    if (to?.meta?.title) {
      document.title = to.meta.title as string;
    }
    if (isNavigationFailure(failure)) {
      console.log("failed navigation", failure);
    }
  });

  router.onError((error) => {
    console.log(error, "路由错误");
    location.reload();
  });
}
